import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ContentSection from './components/ContentSection';
import ArticleCards from './components/ArticleCards';
import CTASection from './components/CTASection';
import TrustSection from './components/TrustSection';
import Footer from './components/Footer';
import { SITE_URL } from '@/constants/site';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Itaobuy Spread',
  url: SITE_URL,
  description: 'La più grande piattaforma italiana di conoscenza dedicata a Itaobuy Spreadsheet. Guide, confronti e strategie per lo shopping online.',
  inLanguage: 'it',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Itaobuy Spread',
  url: SITE_URL,
  description: 'Piattaforma italiana di conoscenza per Itaobuy Spreadsheet',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}></script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}></script>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ContentSection />
        <ArticleCards />
        <CTASection />
        <TrustSection />
      </main>
      <Footer />
    </>
  );
}